<mat-toolbar color="primary">
    <span routerLink="/" class="main">Remedy Sync</span>
    <span class="spacer"></span>
    <div class="options">
        <button mat-icon-button class="option" routerLink="/about">
            ABOUT
          </button>
          <button mat-icon-button class="option" aria-label="Example icon-button with share icon" *ngIf="!userService.loggedIn" routerLink="/login">
            LOGIN
          </button>

          <button mat-icon-button class="option" *ngIf="userService.loggedIn" routerLink="/profile">
            PROFILE
          </button>

          <button mat-icon-button class="option" aria-label="Example icon-button with share icon" *ngIf="userService.loggedIn" (click)="userService.signOut()">
            LOGOUT
          </button>
    </div>
  </mat-toolbar>